"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarGroupInitials = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const avatar_group_initials_style_1 = __importDefault(require("./avatar.group.initials.style"));
class AvatarGroupInitials extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, initials } = this.props;
            return jsx_runtime_1.jsx("div", Object.assign({ className: classes.root }, { children: initials.slice(0, 2) }), void 0);
        };
    }
}
exports.AvatarGroupInitials = AvatarGroupInitials;
AvatarGroupInitials.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    initials: prop_types_1.default.string.isRequired
};
exports.default = react_jss_1.default(avatar_group_initials_style_1.default)(AvatarGroupInitials);
//# sourceMappingURL=avatar.group.initials.js.map